export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = `${base64String}${padding}`.replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let index = 0; index < rawData.length; index += 1) {
    outputArray[index] = rawData.charCodeAt(index);
  }

  return outputArray;
}

export function arrayBufferToBase64Url(buffer: ArrayBuffer | null): string | null {
  if (!buffer) return null;

  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let index = 0; index < bytes.byteLength; index += 1) {
    binary += String.fromCharCode(bytes[index]);
  }

  return window
    .btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function hasCurrentApplicationServerKey(
  applicationServerKey: ArrayBuffer | null,
  publicKey: string,
): boolean {
  return arrayBufferToBase64Url(applicationServerKey) === publicKey;
}

export const PUSH_SYNC_INTERVAL_MS = 12 * 60 * 60 * 1000;

export function isPushSyncDue(
  lastSyncedAtMs: number | null,
  nowMs: number,
  intervalMs: number = PUSH_SYNC_INTERVAL_MS,
): boolean {
  return !lastSyncedAtMs || nowMs - lastSyncedAtMs > intervalMs;
}
